/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Live_TitleInputs */

const en_features_live_title = /** @type {(inputs: Features_Live_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You run the session. Your client sees it live.`)
};

const pl_features_live_title = /** @type {(inputs: Features_Live_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prowadzisz trening. Klient widzi go na żywo.`)
};

/**
* | output |
* | --- |
* | "You run the session. Your client sees it live." |
*
* @param {Features_Live_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_live_title = /** @type {((inputs?: Features_Live_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Live_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_live_title(inputs)
	return en_features_live_title(inputs)
});